export const managementStrings = {
  "acquisition.protected": { en: "This business already has a Qotta account or is unavailable for public analysis. Existing managers can use their Dashboard or contact Qotta for help.", he: "לעסק הזה כבר יש חשבון Qotta או שהוא אינו זמין לניתוח ציבורי. מנהלים קיימים יכולים להשתמש בלוח הבקרה או לפנות ל־Qotta לעזרה." },
};
